<template>
  <ol class="stepper-list list-unstyled mb-0 text-left d-flex flex-direction-column">
    <li v-for="(item, index) in items"
        :key="`step-item-${index}`"
        class="stepper-list__item position-relative d-flex align-items-center"
    >
      <sdui-icon class="icon--border" :class="item.icon ? item.icon : 'icon-radio-unchecked gray-300'" />
      <div class="pl-3">
        <p class="mb-0">{{ item[label] }}</p>
      </div>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'SduiStepper',
  props: {
    label: {
      type: String,
      default: 'text',
    },

    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
.stepper-list {
  --deletion-stepper-line-position: 11px;
  --deletion-stepper-line-width: 2px;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &::before {
    content: '';
    width: var(--deletion-stepper-line-width);
    height: 100%;
    background-color: $color-gray-100;
    position: absolute;
    top: 0;
    left: var(--deletion-stepper-line-position);
    z-index: -1;
  }
}

.stepper-list__item:first-child::before,
.stepper-list__item:last-child::before {
  content: '';
  width: var(--deletion-stepper-line-width);
  height: 50%;
  background-color: $color-white;
  position: absolute;
  left: var(--deletion-stepper-line-position);
  z-index: -1;
}
.stepper-list__item:first-child::before {
  top: 0;
}

.stepper-list__item:last-child::before {
  bottom: 0;
}

.icon--border {
  background-color: $color-white;
  border: 2px solid $color-white;
}
</style>
